/*
 * builds the nice little chart for the user profile page.
 * @author Nat Welch
 */
export { buildGraph };
window.buildGraph = buildGraph;
function buildGraph(graphData) {
   new Highcharts.Chart({
      chart: {
         renderTo: 'activity-graph',
         // zoomType: 'x',
         margin: [10, 10, 20, 50],
         borderColor: '#fff',
      },
      credits: {
         enabled: false,
      },
      colors: ['#febc3e'],
      title: {
         text: null,
      },
      subtitle: {
         text: null,
      },
      xAxis: {
         type: 'datetime',
         dateTimeLabelFormats: {
            day: '%B %d',
            week: '%B %e',
            month: '%B %Y',
            year: '%Y',
         },
         title: {
            text: null,
         },
      },
      yAxis: {
         title: {
            style: {
               color: '#5A5B5E',
            },
            text: null,
         },
         allowDecimals: false,
         min: 1,
         startOnTick: false,
         showFirstLabel: false,
      },
      tooltip: {
         formatter: function () {
            // Uses Mootools Date to format...
            let d = new Date(this.x);
            return d.format('%B %d') + '<br/>' + this.y + ' reputation';
         },
      },
      legend: {
         enabled: false,
      },
      plotOptions: {
         area: {
            lineWidth: 1,
            marker: {
               enabled: false,
               states: {
                  hover: {
                     enabled: true,
                     radius: 3,
                  },
               },
            },
            shadow: false,
            states: {
               hover: {
                  lineWidth: 1,
               },
            },
         },
      },
      series: [
         {
            data: graphData,
            type: 'area',
         },
      ],
   });
}

onDomReady(function () {
   new Request.AjaxIO('buildGraph', {
      onSuccess: function (graphData) {
         if (graphData.length > 1 && $('activity-graph')) {
            $('activity-graph').setStyle('height', '300');
            buildGraph(graphData);
         }
      }.bind(this),
   }).send($('userid').get('text'));
});
